import { render, staticRenderFns } from "./InterviewFredCarl.vue?vue&type=template&id=36d3aa44&scoped=true&"
import script from "./InterviewFredCarl.vue?vue&type=script&lang=js&"
export * from "./InterviewFredCarl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3aa44",
  null
  
)

export default component.exports